'use strict';

import Cart from './checkout/cart';

document.addEventListener('DOMContentLoaded', () => {
    Cart.run();
});

$('body').on('click', '.img-close-icon-sg', function () {
    $('.message-notgift-anymore').addClass('hide');
});

$('.return-info .icon-info-black').on('mouseenter', function (e1) {
    if (Foundation.MediaQuery.atLeast('large')) {
        e1.stopPropagation();
        $(this).closest('.return-info').find('.info-return').removeClass('hide');
        $(this).closest('.return-info').find('.tooltip-background-return').removeClass('hide');
    }
});

$('.return-info .icon-info-black').on('click', function (e1) {
    if (!Foundation.MediaQuery.atLeast('large')) {
        e1.stopPropagation();
        $('body').addClass('noscroll');
        $(this).closest('.return-info').find('.info-return').removeClass('hide');
        $(this).closest('.return-info').find('.tooltip-background-return').removeClass('hide');
        $('body').on('click.closeTooltipEvent', function (e) {
            if ($(e.target).hasClass('close-button-info-tooltip') || $(e.target).closest('.info-return').length === 0) {
                $('body').removeClass('noscroll');
                $('.info-return').addClass('hide');
                $('body').off('click.closeTooltipEvent');
                $('.tooltip-background-return').addClass('hide');
            }
        });
    }
});

$('div.return-info i.info-icon').on('mouseleave', function (e1) {
    if (Foundation.MediaQuery.atLeast('large')) {
        $(this).closest('.return-info').find('.tooltip-background-return').addClass('hide');
        $(this).closest('.return-info').find('.tooltip.info-return').addClass('hide');
    }
});
